// extracted by mini-css-extract-plugin
export default {"buttons":"Buttons_buttons__OOTMJ","mobile":"Buttons_mobile__f3wqf"};